import { CheckIcon } from "@phosphor-icons/react";
import { Button, Flex, Spin, Typography } from "antd";
import { Carousel } from "components/Carousel/";
import { useAntTheme } from "hooks/useAntTheme/";
import { useSystemConfiguration } from "hooks/useSystemConfiguration/";
import { getLocaleCountryCode } from "pages/media/utils/";
import { radius } from "@libertify/ui";

export function ProjectSettingsFormLanguage<T>(
  props: Readonly<{
    value: T | undefined;
    onChange: (value: T) => void;
  }>
) {
  const { theme } = useAntTheme();

  const { supportedLanguagesOptions: languages } = useSystemConfiguration();
  // move English to the beginning of the array
  const indexEnglish = languages.findIndex(
    (language) => language.value === "en-US"
  );
  if (indexEnglish !== -1) {
    const english = languages.splice(indexEnglish, 1)[0];
    languages.unshift(english);
  }

  if (languages.length === 0) return <Spin></Spin>;
  return (
    <Carousel
      slidesToShow={4}
      slidesToScroll={4}
      rows={2}
      style={{
        height: 400,
        marginBottom: 20,
        paddingTop: 30,
      }}
      numberOfElements={languages?.length}
      initialSlide={languages?.findIndex((item) => item.value === props.value)}
    >
      {languages.map((language) => {
        return (
          <Flex key={language?.value}>
            <Flex
              style={{
                margin: 10,
              }}
              align="center"
              justify="center"
            >
              <Button
                style={{
                  width: 300,
                  height: 120,
                  margin: 15,
                  borderRadius: radius.box,
                  boxShadow: `0 0 10px ${theme.colorBorder}`,
                  border: "none",
                }}
                onClick={() => props.onChange(language.value as T)}
                type={language.value === props.value ? "primary" : "default"}
              >
                <Flex
                  align="center"
                  justify="flex-start"
                  style={{
                    width: "100%",
                    height: "100%",
                    position: "relative",
                  }}
                >
                  {language.value === props.value && (
                    <Flex
                      align="center"
                      justify="center"
                      style={{
                        position: "absolute",
                        backgroundColor: theme.colorPrimary,
                        width: 40,
                        height: 40,
                        border: `5px solid ${theme.colorBgElevated}`,
                        borderRadius: radius.circle,
                        color: theme.colorBgElevated,
                        right: -30,
                        top: -10,
                        zIndex: 2,
                      }}
                    >
                      <CheckIcon size={22} />
                    </Flex>
                  )}
                  <Flex
                    align="center"
                    justify="center"
                    style={{
                      width: 50,
                      height: 50,
                      border: `1px solid ${theme.colorPrimary}`,
                      borderRadius: 20,
                      marginRight: 10,
                      backgroundColor: "rgba(255, 255, 255, 0.5)",
                    }}
                  >
                    <div
                      className={`fi-${getLocaleCountryCode(language.description)}`}
                      style={{
                        width: "22px",
                        height: "18px",
                        backgroundSize: "contain",
                        backgroundRepeat: "no-repeat",
                      }}
                    ></div>
                  </Flex>
                  <Typography.Text
                    type="secondary"
                    style={{
                      color:
                        language.value === props.value
                          ? theme.colorBgElevated
                          : "",
                      fontSize: 16,
                      whiteSpace: "normal",
                      letterSpacing: "-5%",
                    }}
                  >
                    {language.label}
                  </Typography.Text>
                </Flex>
              </Button>
            </Flex>
          </Flex>
        );
      })}
    </Carousel>
  );
}
